import type { WidaStudent } from '../Upload/widaHistory';
import type { SisStudent } from '../Upload/sisRoster';
import {
  computeClassificationTenure,
  resolveStartedInDistrict,
} from '../../core/classificationTenure';
import { loadThresholds, type Thresholds } from '../../core/thresholds';
import type { PlanStudent } from './derive';
import { schoolYearEndForDate } from '../../core/schoolYear';

export function enrichWithSis(
  wida: WidaStudent,
  sis: SisStudent | null,
  thresholds: Thresholds = loadThresholds(),
  now: Date = new Date(),
): PlanStudent {
  if (!sis) return { ...wida, thresholds };

  const adminYears = wida.years.map((y) => y.year);
  const currentYear = Math.max(schoolYearEndForDate(now), ...adminYears);
  const earliestWidaYear = adminYears.length > 0 ? Math.min(...adminYears) : null;

  const hasTenureSignal =
    sis.serviceStartYear != null ||
    sis.yearsInEl != null ||
    sis.newcomerFlag != null ||
    sis.originatingDistrict != null;

  const tenure = hasTenureSignal
    ? computeClassificationTenure({
        serviceStartYear: sis.serviceStartYear,
        yearsInEl: sis.yearsInEl ?? wida.yearsInEl,
        startedInDistrict: resolveStartedInDistrict(sis.originatingDistrict, wida.district),
        newcomerFlag: sis.newcomerFlag,
        earliestWidaYear,
        currentYear,
        thresholds,
      })
    : undefined;

  return {
    ...wida,
    yearsInEl: tenure?.tenure.yearsInProgram ?? wida.yearsInEl,
    nativeLanguage: sis.homeLanguage ?? wida.nativeLanguage,
    latestSchool: sis.school || wida.latestSchool,
    latestGrade: sis.grade || wida.latestGrade,
    sis,
    thresholds,
    ...(tenure ? { tenure } : {}),
  };
}

